function MultipleIcon({ height = '24', width = '24', color = 'currentColor', opacity = '1' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M10 12L16 1L22 12L16 23L10 12ZM6 12L11.675 1.575L12.825 3.675L8.275 12L12.825 20.325L11.675 22.425L6 12ZM2 12L7.675 1.575L8.825 3.675L4.275 12L8.825 20.325L7.675 22.425L2 12ZM12.275 12L16 18.825L19.725 12L16 5.175L12.275 12Z"
        fill={color}
        fill-opacity={opacity}
      />
    </svg>
  );
}

export default MultipleIcon;
